import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { BugReportService } from '../services/bug-report.service';

@Injectable()
export class NetworkLoggerInterceptor implements HttpInterceptor {
  constructor(private bugReportService: BugReportService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Log request
    this.bugReportService.addNetworkLog({
      timestamp: new Date(),
      type: 'request',
      url: request.url,
      method: request.method,
      body: request.body
    });

    return next.handle(request).pipe(
      tap(
        (event) => {
          if (event instanceof HttpResponse) {
            // Log successful response
            this.bugReportService.addNetworkLog({
              timestamp: new Date(),
              type: 'response',
              url: event.url || request.url,
              status: event.status,
              body: event.body
            });
          }
        },
        (error: HttpErrorResponse) => {
          // Log error response
          this.bugReportService.addNetworkLog({
            timestamp: new Date(),
            type: 'error',
            url: error.url || request.url,
            status: error.status,
            body: error.error
          });
        }
      )
    );
  }
}
